import React from "react";
import PropTypes from "prop-types";


export default function DockSplitPane({
  node,
  renderNode,
}) {
  return (
    <section
      className={[
        "studio-dock-split",
        `studio-dock-split--${node.orientation}`,
      ].join(" ")}
      data-dock-node-id={node.id}
    >
      {node.children.map((child, index) => (
        <div
          key={child.id}
          className="studio-dock-split__child"
          style={{
            flexBasis: `${node.sizes[index]}%`,
          }}
        >
          {renderNode(child)}
        </div>
      ))}
    </section>
  );
}


DockSplitPane.propTypes = {
  node: PropTypes.shape({
    id: PropTypes.string.isRequired,
    orientation: PropTypes.oneOf([
      "horizontal",
      "vertical",
    ]).isRequired,
    children: PropTypes.array.isRequired,
    sizes: PropTypes.arrayOf(
      PropTypes.number,
    ).isRequired,
  }).isRequired,
  renderNode: PropTypes.func.isRequired,
};
